module.exports = __webpack_public_path__ + "media/images/article/2022_02_b-526c7a4ead862f79cbebd216c82d77a8.png";